import React, { useEffect, useState } from 'react';
import {
    Button,
    FlexDirectionRow,
    FormInputRadio,
    MainContent,
    SubTitle
} from "../../../../../components/StyledComponents";
import { Grid } from "@mui/material";
import { valueIsRequired } from "../../../../../utils/regex";
import Select from "../../../../../components/Select";
import { useApp } from "../../../../../context/app";
import { useFieldArray, useForm } from "react-hook-form";
import Input from "../../../../../components/InputControlled";
import { parseStringToJson } from "../../../../../utils/utils";
import Search from "@material-ui/icons/Search";
import Spinner from "react-spinner-material";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext, BaSeIcon } from "@base/react";
import { DiagnosticoService } from "../../../services/diagnosticoService";

export const Incluir = () => {
    
    const {showModal} = React.useContext(BaSeDialogContext);
    const {setRenderIncludeScreen, manageItem} = useApp();
    const {control, handleSubmit, watch, reset, register, setValue, clearErrors, setError} = useForm({
        defaultValues: {
            uf: '',
        }
    });
    
    const {fields, replace} = useFieldArray({
        control,
        name: "diagnosticosArray",
    });
    
    const diagnosticos = watch('diagnosticosArray');
    const [ufs, setUfs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [notFoundError, setNotFoundError] = useState(null);
    const [isSubimited, setIsSubmited] = useState(false);
    
    useEffect(() => {
        const subscription = watch((value, {name}) => {
            if (name === 'uf') {
            }
            return value
        });
        return () => subscription.unsubscribe();
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch]);
    
    
    const onResetFields = () => {
        reset();
    }
    
    const getOptions = async () => {
        const response = await DiagnosticoService.getFilterOptions(false);
        if (response) {
            setUfs(response.ufs)
        }
        setIsLoading(false);
    }
    
    const getDiagnosticosByUf = async () => {
        setIsLoading(true);
        setNotFoundError(null);
        const uf = parseStringToJson(watch('uf')) || null;
        if (!uf) {
            setError('uf', {message: 'Selecione uma UF'});
            setIsLoading(false);
            return;
        }
        try {
            const response = await DiagnosticoService.getDiagnosticosSas(uf.sigla);
            if (!response?.length) {
                replace([]);
                setNotFoundError('Não foram encontrados diagnósticos disponíveis para esta UF.');
                setIsLoading(false);
                return;
            }
            replace(response);
            clearErrors('uf');
            setNotFoundError(null);
            setIsLoading(false);
            return response
        } catch (e) {
            replace([]);
            if (e?.response?.data?.descricao?.includes('Chave Inválida')) {
                setNotFoundError(
                    <>
                        <p style={{color: '#646363'}}>Não existe token de acesso cadastrado para esta UF.
                            <span style={{color: '#0062C7'}}> Atualize o token</span>
                        </p>
                    </>);
                setIsLoading(false);
                return;
                
            }
            setNotFoundError('Não foram encontrados diagnósticos disponíveis para esta UF.');
            setIsLoading(false);
        }
    }
    
    const submitForm = async (dataForm) => {
        setIsSubmited(true);
        const diagnosticosParaIncluir = dataForm?.diagnosticosArray
            .filter(d => d?.checked)
            .map(diagnostico => {
                const {checked, ...rest} = diagnostico;
                return rest;
            });
        if (!diagnosticosParaIncluir?.length) return;
        await createItem(diagnosticosParaIncluir);
    }
    
    const handleGoHome = () => {
        setRenderIncludeScreen(false);
    };
    
    const createItem = async (dataForm) => {
        DiagnosticoService.save(dataForm)
            .then((response) => {
                console.log('response', response)
                handleModalStatus({
                    type: "success",
                    msgOnSuccess: "Diagnóstico foi cadastrado com sucesso.",
                    onCloseModal: handleGoHome,
                    showModal,
                });
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.descricao
                if (errorMessage) {
                    handleModalStatus({
                        type: "error",
                        msgOnError: errorMessage,
                        showModal,
                    })
                    return;
                }
                handleModalStatus({
                    type: "error",
                    msgOnError:
                    error?.response?.data?.message ??
                        "O Diagnóstico não foi cadastrado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
                    showModal,
                })
            })
            .finally(() => {
                setIsSubmited(false);
            })
    }
    
    const marcarOpcao = (index) => {
        const options = [...diagnosticos];
        const optionSelected = options[index];
        options[index].checked = !optionSelected?.checked;
        setValue('diagnosticosArray', options);
    }
    
    useEffect(() => {
        getOptions()
    }, []);
    
    return (
        <>
            <MainContent>
                <SubTitle>
                    <h3>{manageItem?.data?.id ? "Editar" : "Incluir"}</h3>
                </SubTitle>
                
                
                <Grid
                    container
                    style={{paddingBottom: "30px"}}
                >
                    <Grid container item alignItems={"center"}>
                        <Grid item md={1}>
                            <Select
                                name="uf"
                                returnItem
                                defaultName="sigla"
                                placeholder="UF"
                                options={ufs}
                                control={control}
                                rules={{...valueIsRequired()}}
                            />
                        
                        </Grid>
                        <Grid item ml={4}>
                            <Search htmlColor={'#0061C6'} onClick={() => getDiagnosticosByUf()} style={{
                                height: '33px',
                                fontSize: '31px',
                                marginTop: '4px',
                                cursor: 'pointer'
                            }}/>
                        </Grid>
                    </Grid>
                    
                    
                    {isLoading ? (
                            <Grid container item alignItems={"center"} justifyContent={'center'}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}>
                                    <Spinner radius={80} color={'#0061C6'} stroke={2} visible={true}/>
                                    <p>Carregando...</p>
                                </div>
                            </Grid>
                        ) :
                        (
                            <>
                                <Grid container item alignItems={"center"} mb={4}>
                                    <p style={{
                                        color: '#0061C6',
                                        fontStyle: 'bold',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        lineHeight: '17px',
                                    }}>Diagnósticos disponíveis</p>
                                </Grid>
                                {
                                    (!notFoundError && !!diagnosticos?.length) &&
                                    <Grid container alignItems="center">
                                        
                                        <Grid container>
                                            <Grid item md={1} mr={4}>
                                                <p>ID</p>
                                            </Grid>
                                            
                                            <Grid item md={2}>
                                                <p>Nome diagnóstico</p>
                                            </Grid>
                                        </Grid>
                                        
                                        {
                                            fields?.map((f, index) => (
                                                <Grid container key={index} alignItems="center">
                                                    <Grid item md={1} mr={4}>
                                                        <Input
                                                            disabled={true}
                                                            control={control}
                                                            {...register(`diagnosticosArray.${index}.idDiagnostico`)}
                                                        />
                                                    </Grid>
                                                    
                                                    <Grid item md={3}>
                                                        <Input
                                                            disabled={true}
                                                            control={control}
                                                            {...register(`diagnosticosArray.${index}.nome`)}
                                                        />
                                                    </Grid>
                                                    
                                                    <Grid item ml={4} mt={-1.3} alignItems='center'>
                                                        <FormInputRadio type="radio"
                                                                        checked={f?.checked}
                                                                        onClick={() => marcarOpcao(index)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ))
                                        }
                                    
                                    </Grid>
                                }
                                
                                {
                                    (!!notFoundError && !diagnosticos?.length) &&
                                    <Grid container>
                                        <div style={{
                                            height: '40px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            backgroundColor: 'rgba(196, 196, 196, 0.32)',
                                            alignItems: 'center',
                                            padding: '3px 7px'
                                        }}>
                                            <>
                                                <BaSeIcon
                                                    name="exclamation-circle"
                                                    size={28}
                                                    color="#ff0000"
                                                    description={'description'}/>
                                                <p style={{marginLeft: '4px'}}>
                                                    {notFoundError}
                                                </p>
                                            </>
                                        </div>
                                    </Grid>
                                }
                            
                            </>
                        )
                        
                    }
                    
                    
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <FlexDirectionRow position={"end"}>
                                {
                                    !manageItem?.data?.id &&
                                    <Button
                                        href="#"
                                        backgroundColor={"#9CA2A8"}
                                        onClick={onResetFields}
                                    >
                                        Limpar
                                    </Button>
                                }
                                
                                <div style={{marginLeft: "10px", marginRight: "10px"}}/>
                                <Button
                                    href="#"
                                    disabled={isSubimited}
                                    onClick={handleSubmit(submitForm)}
                                >
                                    {isSubimited ? (
                                        <Spinner radius={16} color={"#fff"} stroke={2} visible={true}/>
                                    ) : (
                                        "Incluir diagnóstico"
                                    )}
                                </Button>
                            </FlexDirectionRow>
                        </Grid>
                    </Grid>
                </Grid>
            </MainContent>
        </>
    )
}
